module.exports = __webpack_public_path__ + "static/bg-flower-250b8f730a35e7bf1e4a0c9bd6e2802f.jpg";